<template>
  <div class="uyh-mantra-select">


    <!-- Camera message if image and unsupported -->
    <div v-if="resource === 'image' && !cameraAvailable" class="camera-not-supported">
      <p>Sorry, we are unable to access your camera! Please close and try uploading a photo instead.</p>
    </div>


    <!-- Slider -->
    <button class="prevArrow">
      <svg svg-inline="" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg>
    </button>

    <div v-if="resource === 'image'" class="uyh-mantra-slider">
      <ImageMantraGridItem v-for="mantra in mantras"
                      :key="mantra.id"
                      :mantraid="mantra.id"
                      :primary="mantra.presets.primarybackground"
                      :secondary="mantra.presets.secondarybackground"
                      :textarea="mantra.presets.textareacolor"
                      :textcolor="mantra.presets.textcolor"
                      :textweight="mantra.presets.textstyle"
                      :textareaborder="mantra.presets.textareaborder"
                      :icon="mantra.icon"
                      :hashtag="mantra.hashtag"
                      :message="mantra.message"/>
    </div>

    <div v-else-if="resource === 'text'" class="uyh-mantra-slider">
      <TextMantraGridItem v-for="mantra in mantras"
                      :key="mantra.id"
                      :mantraid="mantra.id"
                      :primary="mantra.presets.primarybackground"
                      :secondary="mantra.presets.secondarybackground"
                      :textarea="mantra.presets.textareacolor"
                      :textcolor="mantra.presets.textcolor"
                      :textweight="mantra.presets.textstyle"
                      :textareaborder="mantra.presets.textareaborder"
                      :icon="mantra.icon"
                      :hashtag="mantra.hashtag"
                      :message="mantra.message"/>
    </div>
    <button class="nextArrow">
      <svg svg-inline="" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg>
    </button>


    <!-- Dynaic CTA buttons -->
    <button v-if="resource === 'image' && windowWidth > 1023" class="takePicture" @click="takePicture">
      <svg svg-inline="" role="presentation" focusable="false" width="45" height="45" viewBox="0 0 45 45" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><image x="39" width="45" height="45" xlink:href="data:image/png;base64,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" transform="translate(-39)" fill="none" fill-rule="evenodd"/></svg>
      {{ $t('get_image.take_picture') }}
    </button>

    <button v-if="resource === 'image' && windowWidth > 1023" class="selectPicture" @click="selectPicture">
      <svg svg-inline="" role="presentation" focusable="false" width="37" height="43" viewBox="0 0 37 43" xmlns="http://www.w3.org/2000/svg"><g stroke="#223628" stroke-width="3" fill="none" fill-rule="evenodd"><rect x="1.5" y="1.5" width="24.564" height="30.077" rx="3"/><rect fill="#FCEFF3" x="10.321" y="11.423" width="24.564" height="30.077" rx="3"/></g></svg>
      {{ $t('get_image.select_picture') }}
    </button>

    <button v-if="resource === 'image' && windowWidth < 1024" class="selectPicture" @click="selectMobilePicture">
      <svg svg-inline="" role="presentation" focusable="false" width="46" height="52" viewBox="0 0 46 52" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><g fill="#FCEFF3" stroke="#223628" stroke-width="3"><rect x="1.5" y="1.5" width="25.369" height="31.043" rx="3"/><rect x="10.578" y="11.713" width="25.369" height="31.043" rx="3"/></g><g transform="translate(26.553 33.191)"><circle fill="#223628" cx="9.404" cy="9.404" r="9.404"/><g stroke="#FC7CA0" stroke-linecap="square" stroke-width="2"><path d="M5.2 9.548h8.563M9.626 5.123v8.563"/></g></g></g></svg>
      {{ $t('get_image.select_picture_mobile') }}
    </button>

    <button v-if="resource === 'text'" @click="editMantra" class="uyh-btn next">{{ $t('navigation.next') }}</button>
  </div>
</template>

<script>
  import TextMantraGridItem from './Text_MantraGridItem.vue';
  import ImageMantraGridItem from './Image_MantraGridItem.vue';
  import TextMantraData from './../assets/text_mantras.json';
  import ImageMantraData from './../assets/image_mantras.json';
  import getCookie from '@/assets/javascripts/get_cookie';

  export default {
    name: 'mantra_index',
    data: function (){
      if (this.$route.params.resource === 'text') {
        return TextMantraData
      } else if (this.$route.params.resource === 'image') {
        return ImageMantraData
      }
    },
    components: {
      TextMantraGridItem,
      ImageMantraGridItem
    },
    methods: {
      widowWidth: function() {
        this.windowWidth = window.innerWidth;
      },
      takePicture: function(e) {
        var supported = 'mediaDevices' in navigator;
        if (supported) {
          this.updateDataLayer(this.$t('get_image.take_picture'));
          this.$emit('show-take-picture');
        } else {
          this.cameraAvailable = false;
        }
      },
      selectPicture: function(e) {
        this.updateDataLayer(this.$t('get_image.select_picture'));
        this.$emit('show-gallery-upload');
      },
      selectMobilePicture: function(e) {
        this.updateDataLayer(this.$t('get_image.select_picture_mobile'));
        this.$emit('show-gallery-upload');
      },
      updateDataLayer: function(title) {
        window.dataLayer.push({
          'event': 'nav-click',
          'clickPath': '',
          'clickTitle': title,
          'locale': getCookie('lang')
        });
      },
      editMantra: function() {
        this.$emit('loader-active');
        var activeSlide = document.querySelector('.slick-current');
        var link = activeSlide.querySelector('a').getAttribute('href');
        if (link.includes('#')) {
          link = link.split('#')[1];
        }
        this.$router.push(link);
      },
      initSlick: function() {
        const $ = window.jQuery;
        var next = $('.nextArrow');
        var prev = $('.prevArrow');
        var options = {
          arrows: true,
          centerMode: true,
          centerPadding: '0',
          dots: false,
          infinite: true,
          nextArrow: next,
          prevArrow: prev,
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 300,
          responsive: [
            {
              breakpoint: 1199,
              settings: {
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                dots: true,
                slidesToShow: 1
              }
            }
          ]
        };

        $('.uyh-mantra-slider').slick(options);
      },
      checkSlick: function() {
        let slider = document.querySelector('.uyh-mantra-slider')
        if (slider.classList.contains('slick-initialized')) {
          clearInterval(window.slickChecker);
          window.slickChecker = undefined;
        } else {
          this.initSlick()
        }
      }
    },
    beforeMount: function() {
      this.resource = this.$route.params.resource;
    },
    mounted: function() {
      this.$nextTick(function() {
        window.addEventListener('resize', this.widowWidth);
        this.widowWidth();
      });
      let $this = this;
      window.slickChecker = setInterval($this.checkSlick, 50);
    },
    destroyed: function() {
      document.removeEventListener('resize', this.widowWidth);
    }
  }
</script>

<style lang="scss">
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-portrait-down-breakpoint: 1023px;
    $tablet-portrait-breakpoint: 1024px;
    $tablet-down-breakpoint: 1199px;
    $hd-desktop-breakpoint: 1280px;

    [class*="slick-"] {
      transition: none;
    }

    .camera-not-supported {
      background-color: #223628;
      border: 2px solid #fceff3;
      left: 50%;
      padding: 32px;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 17;
      p {
        color: #fceff3;
      }
    }

    .slick-list {
      overflow: visible;
    }

    .uyh-mantra-select {
      padding-bottom: 26px;
      position: relative;
    }

    .uyh-mantra-slider {
      left: 50%;
      position: relative;
      transform: translateX(-50%);
      width: 150%;
    }

    .responsivesite button.prevArrow,
    .responsivesite button.nextArrow,
    .prevArrow,
    .nextArrow {
      background: transparent;
      border: none;
      display: inline-block;
      height: initial;
      line-height: 0;
      max-height: none;
      margin: 0;
      overflow: hidden;
      padding: 0;
      position: absolute;
      text-align: center;
      top: calc(50% - 56px);
      transform: translateY(-50%);
      width: 30px;
      z-index: 18;
      svg {
        max-height: 100%;
      }
    }
    .prevArrow {
      left: 25%;
    }
    .nextArrow {
      right: 25%;
      svg {
        transform: rotate(180deg);
      }
    }

    button {
      &.takePicture,
      &.selectPicture {
        background: transparent;
        border: none;
        font-size: 20px;
        margin: 47px 38.75px 0;
        max-width: 50%;
        padding: 0;
        text-align: center;
        width: 161px;
        line-height: 20px;
        @media screen and (max-width: $tablet-portrait-down-breakpoint) {
          margin: 20px 17.25px 0;
        }
        svg {
          display: block;
          margin: 0 auto;
          position: relative;
          width: 45px;
        }
        @media screen and (min-width: $tablet-portrait-breakpoint) and (max-width: $hd-desktop-breakpoint) {
          margin-top: 37px;
        }
      }
      &.takePicture {
        svg {
          margin-bottom: 6px;
        }
      }
      &.selectPicture {
        svg {
          margin-bottom: 8px;
        }
      }
    }

    .uyh-btn {
      &.next {
        height: 45px;
        font-size: 20px;
        line-height: 45px;
        margin-top: 67px;
        padding: 0;
        width: 150px;
        @media screen and (min-width: $tablet-portrait-breakpoint) and (max-width: $hd-desktop-breakpoint) {
          height: 40px;
          line-height: 40px;
          margin-top: 37px;
        }
      }
    }

    // Landscape tablet top
    @media screen and (max-width: 1199px) {
      .responsivesite button.prevArrow,
      .responsivesite button.nextArrow,
      .prevArrow,
      .nextArrow {
        display: none;
      }

      .slick-dots {
        display: block !important;
        list-style: none;
        margin: 63px 0 0;
        padding: 0;
        li {
          display: inline-block;
          margin: 0 3.5px;
          button {
            background-color: transparent;
            border: none;
            font-size: 1px;
            height: 6px;
            line-height: 1;
            overflow: hidden;
            padding: 0;
            width: 6px;
            &:before {
              border: 1px solid #22372b;
              border-radius: 100%;
              content: '';
              display: block;
              height: 4px;
              width: 4px;
            }
          }
          &.slick-active {
            button {
              &:before {
                background-color: #22372b;
              }
            }
          }
        }
      }

      .uyh-btn {
        &.next {
          margin-top: 35px;
        }
      }
    }

    // Portrait tablet top
    @media screen and (max-width: 1023px) {
    }

    // Mobile top
    @media screen and (max-width: 767px) {
      .uyh-mantra-slider {
        width: 100%;
      }
      .slick-dots {
        margin: 20px 0 0;
      }
      .uyh-btn {
        &.next {
          margin-top: 20px;
        }
      }
    }
  }
</style>
